import React from "react";

/**
 * FloatingChip — tilted "screenshot-of-the-app" UI pill that floats in the
 * hero diorama. Each chip is positioned absolutely by its parent.
 *
 * Variants:
 *   • payment  — "Paid 0.042 ETH · 12s ago" with a green status dot
 *   • boost    — "+$2,500 USDC" with a coin glyph
 *   • split    — "Auto-split → 3 contributors"
 *   • channel  — "@nikolai.eth · 2,418 paid"
 */
const FloatingChip = ({ variant, tilt = 0, className = "", style }) => {
  const tiltStyle = {
    transform: `rotate(${tilt}deg)`,
    ...style,
  };

  if (variant === "payment") {
    return (
      <div
        data-testid={`chip-payment`}
        className={`l2-pill l2-bob-slow ${className}`}
        style={tiltStyle}
      >
        <span
          className="relative inline-flex w-2 h-2"
          aria-hidden
        >
          <span
            className="absolute inset-0 rounded-full animate-ping opacity-70"
            style={{ background: "#3FB97A" }}
          />
          <span
            className="absolute inset-0 rounded-full"
            style={{ background: "#3FB97A" }}
          />
        </span>
        <span className="l2-mono text-[12px]">
          Paid <strong className="font-bold">0.042 ETH</strong> · 12s ago
        </span>
      </div>
    );
  }

  if (variant === "boost") {
    return (
      <div
        data-testid={`chip-boost`}
        className={`l2-pill l2-bob ${className}`}
        style={tiltStyle}
      >
        <span
          className="w-5 h-5 rounded-full flex items-center justify-center l2-display"
          style={{
            background: "var(--l2-coin-usdc)",
            color: "var(--l2-paper)",
            fontSize: "10px",
          }}
        >
          $
        </span>
        <span className="l2-mono text-[12px]">
          <strong className="font-bold">+$2,500</strong> USDC
        </span>
      </div>
    );
  }

  if (variant === "split") {
    return (
      <div
        data-testid={`chip-split`}
        className={`l2-pill l2-pill-dark l2-bob-fast ${className}`}
        style={tiltStyle}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
          <path d="M6 3v6m0 0a3 3 0 0 0 3 3h6a3 3 0 0 1 3 3v6M6 9a3 3 0 0 1 3 3" />
        </svg>
        <span className="l2-mono text-[12px]">
          Auto-split → <strong className="font-bold">3 contributors</strong>
        </span>
      </div>
    );
  }

  if (variant === "channel") {
    return (
      <div
        data-testid={`chip-channel`}
        className={`l2-pill l2-bob ${className}`}
        style={tiltStyle}
      >
        <span
          className="w-5 h-5 rounded-full flex items-center justify-center l2-display"
          style={{
            background: "linear-gradient(135deg, var(--l2-peach-2), var(--l2-pink))",
            color: "var(--l2-ink)",
            fontSize: "10px",
          }}
        >
          N
        </span>
        <span className="l2-mono text-[12px]">
          @nikolai.eth · <strong className="font-bold">2,418 paid</strong>
        </span>
      </div>
    );
  }

  return null;
};

export default FloatingChip;
